import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Stack,
  Grid,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AiFillCamera } from 'react-icons/ai';
import { TiLocation } from 'react-icons/ti';
import { Link, useNavigate } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { userDataFromLocal } from '../utils/getUserDetails';
import DialogMsg from '../../global/DialogMsg';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const { GetStartUpConfig, GetLocationForLatLong, GetLanguages, GetKYCStatus } =
  onBoardingEkycServices;

const SelfRegistration = ({ setLanguages, vkycStatus, setVkycStatus }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [getStartUpConfigResponse, setGetStartUpConfigResponse] = useState('');
  const [open, setOpen] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [geoPosition, setPosition] = useState('');
  const [openDialogKyc, setOpenDialogKyc] = useState(false);
  // const [vkycStatus, setVkycStatus] = useState(null);
  const [msg, setMsg] = useState('');

  console.log('getStartUpConfigResponse', getStartUpConfigResponse);
  console.log('geoPosition', geoPosition);

  // location function
  const getLocation = async () => {
    let position = {};
    let positionForApi = '';
    function showPosition(position) {
      if (position.coords) {
        handleGetLocation({
          Latitude: position.coords.latitude,
          Longitude: position.coords.longitude
        });
      }
      setPosition({
        Latitude: position.coords.latitude,
        Longitude: position.coords.longitude
      });
      position = {
        Latitude: position.coords.latitude,
        Longitude: position.coords.longitude
      };
    }

    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      if (permissionStatus.state == 'prompt') {
        // ask for permission and set it to local storage
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            function (position) {
              showPosition(position);
            },
            function (e) {
              const isSafari = window.safari !== undefined;
              const userAgent = window.navigator.userAgent;
              if (isSafari || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                // handleClickOpenFirstDialogBox();
              }
            }
          );
        } else {
          setMsg('Geolocation is not supported by this browser.');
        }
      }

      if (permissionStatus.state === 'granted') {
        navigator.geolocation.getCurrentPosition(
          function (geoposition) {
            // setHideDailog(true);

            const newPosition = {
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            };
            setPosition({
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            });

            positionForApi = newPosition;
            // const geolocation1 = CryptoJS.AES.encrypt(
            //   JSON.stringify(newPosition),
            //   'SrpUserGeoLocation'
            // ).toString();

            // localStorage.setItem(
            //   'e13ehdnf06b-72p6-4581-86a3-c0a465e63d75-Location',
            //   JSON.stringify(geolocation1)
            // );
            handleGetLocation(newPosition);
            /* You can use this position without prompting the user if the permission had already been granted */
          },
          function (e) {
            const isSafari = window.safari !== undefined;
            const userAgent = window.navigator.userAgent;
            if (isSafari || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
              // handleClickOpenFirstDialogBox();
            }
          }
        );
      }

      if (permissionStatus.state == 'denied') {
        // handleClickOpenFirstDialogBox();
      }

      permissionStatus.onchange = () => {
        if (permissionStatus.state === 'granted') {
          // get location
          navigator.geolocation.getCurrentPosition(function (geoposition) {
            const newPosition = {
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            };
            setPosition({
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            });

            positionForApi = newPosition;
            // const geolocation1 = CryptoJS.AES.encrypt(
            //   JSON.stringify(newPosition),
            //   'SrpUserGeoLocation'
            // ).toString();

            // localStorage.setItem(
            //   'e13ehdnf06b-72p6-4581-86a3-c0a465e63d75-Location',
            //   JSON.stringify(geolocation1)
            // );

            handleGetLocation(newPosition);

            /* You can use this position without prompting the user if the permission had already been granted */
          });

          // setLocationPopUp(false);
          // setHideDailog(true);

          // setOpenValidation(false);
          // setValidationMsg('');
        }
        if (permissionStatus.state == 'denied') {
          // setLocationPopUp(true);
          // handleClickOpenFirstDialogBox();
        }
      };
    });
  };

  // handleGetLocation API
  const handleGetLocation = async (position) => {
    try {
      // const localStorageKey = localStorage.getItem('journey');
      // const localStorageParsedData = JSON.parse(localStorageKey).applicationNo;

      let existingJourney = localStorage.getItem('journey');
      // If 'journey' already exists, parse it from JSON
      existingJourney = existingJourney ? JSON.parse(existingJourney) : {};

      setOpenloader(true);
      const credential = {
        channel: 'W',
        applicationNo: existingJourney.applicationNo,
        lng: btoa(decodeURIComponent(encodeURIComponent(position?.Longitude || ''))),
        lat: btoa(decodeURIComponent(encodeURIComponent(position?.Latitude || '')))
      };
      const GetLocationResponse = await GetLocationForLatLong(credential);
      if (GetLocationResponse.status === 'SUCCESS') {
        setOpen(false);
        setOpenSec(true);
        // set location(address) in localStorage
        const newData = {
          ...existingJourney,
          address: GetLocationResponse.data
        };
        localStorage.setItem('journey', JSON.stringify(newData));
      }
    } catch (error) {
      // console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [openSec, setOpenSec] = React.useState(false);

  const handleClickOpenSec = () => {
    // setOpen(false);
    // setOpenSec(true);
    getLocation();

    // handleGetLocation();
  };

  const handleCloseSec = () => {
    setOpenSec(false);
  };

  // get start configuration API which is master API
  const GetStartUpConfigApi = async () => {
    try {
      const GetStartUpConfigResponse = await GetStartUpConfig();
      if (
        GetStartUpConfigResponse.status === 'Success' &&
        Object.keys(GetStartUpConfigResponse.data).length > 0
      ) {
        setGetStartUpConfigResponse(GetStartUpConfigResponse.data);
      }
    } catch (error) {
      console(error);
    }
  };

  // getTutorialAPI API
  const getLanguagesAPI = async () => {
    try {
      setOpenloader(true);
      const getLanguagesResponse = await GetLanguages();
      if (getLanguagesResponse.status === 'Success' && getLanguagesResponse.data.length > 0) {
        setLanguages(getLanguagesResponse.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // GetKYCStatus API
  const GetKYCStatusApi = async () => {
    try {
      const userData = userDataFromLocal();
      setOpenloader(true);
      const hdrCredential = {
        applicationNo: userData?.applicationNo,
        kycType: 'FRESH_KYC',
        mobileNo: userData?.mobileNumber
      };
      const GetKYCStatusResponse = await GetKYCStatus(hdrCredential);
      if (GetKYCStatusResponse.status === 'SUCCESS') {
        setVkycStatus(GetKYCStatusResponse.data);
        // setVkycStatus({
        //   VKYC_STATUS: 'PENDING',
        //   VKYC_DATE: '',
        //   KYC_STATUS: 'COMPLETED',
        //   // KYC_STATUS: 'COMPLETED',
        //   KYC_DATE: ''
        // });
      } else if (GetKYCStatusResponse.status === 'error' || GetKYCStatusResponse.status === 500) {
        setDialogMsg(
          GetKYCStatusResponse.error !== undefined
            ? GetKYCStatusResponse.error
            : 'Server error, Please retry login again'
        );

        setOpenDialogeMsg(true);
      } else {
        setDialogMsg(t('Something went wrong'));
        setOpenDialogeMsg(true);
      }
    } catch (error) {
      // console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  // // Open Dialog Kyc handler
  // const dialogKycHandler = () => {
  //   setOpenDialogKyc(true);
  // };

  useEffect(() => {
    GetStartUpConfigApi();
    getLanguagesAPI(); // langauge API call
    GetKYCStatusApi(); // getkycStatus to check video KYC is remaining
  }, []);

  return (
    <>
      {/* <CssBaseline /> */}
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Home" />
      {/* <PageHeading pageTitle={t('Home')} /> */}
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box className="selfRegistrationBox">
          <Grid container spacing={{ xs: 1, sm: 3, md: 5 }} md={9}>
            <Grid item xs={12} sm={6} md={6}>
              <Box className="SelfRegi">
                <Typography className="cardIcon">
                  <img src="/static/icons/kyc_registration.svg" alt="KYC registration" />
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="cardHeading"
                  sx={{ fontWeight: 'bold' }}
                  mb={2}
                >
                  {t('KYC Registration')}
                </Typography>
                {/* <Typography variant="body2" style={{ minHeight: '50px', marginBottom: '15px' }}>
                    Lorem ipsum is simply dummy text of the printing.
                  </Typography> */}
                <Box Container justifyContent="center" alignItems="center" textAlign="center">
                  <Button
                    onClick={() => {
                      if (vkycStatus?.KYC_STATUS === 'COMPLETED') {
                        setOpenDialogKyc(true);
                      } else {
                        handleClickOpen();
                      }
                    }}
                    className="mainBtn btnLink"
                    // disabled={vkycStatus?.KYC_STATUS === 'PENDING' ? false : true}
                    // disabled={
                    //   vkycStatus?.KYC_STATUS === 'PENDING' &&
                    //   vkycStatus?.VKYC_STATUS === 'PENDING'
                    //     ? false
                    //     : true
                    // }
                  >
                    {t('Click for Registration')}
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Box className="SelfRegi">
                <Typography className="cardIcon">
                  <img src="/static/icons/registration_result.svg" alt="Registration result" />
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="cardHeading"
                  sx={{ fontWeight: 'bold' }}
                  mb={2}
                >
                  {t('Registration Result')}
                </Typography>
                {/* <Typography variant="body2" style={{ minHeight: '50px', marginBottom: '15px' }}>
                    Lorem ipsum is simply dummy text of the printing.
                  </Typography> */}
                <Box Container justifyContent="center" alignItems="center" textAlign="center">
                  <Button
                    onClick={() => navigate('/in/registration-result')}
                    className="mainBtn btnLink"
                    disabled={vkycStatus?.KYC_STATUS === 'COMPLETED' ? false : true}
                  >
                    {t('Click for Result')}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="popupBlue popupBox"
        >
          <DialogTitle id="alert-dialog-title" className="popupBlueHeading">
            <Box className="popupIconBox">
              <TiLocation className="popupIcon" />
            </Box>
            <Typography variant="subtitle1" color="white">
              {t('Allow GPS access')}
            </Typography>
            <Typography variant="subtitle1" color="white">
              {t('Location while you use the app')}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="subtitle1" className="popUpHeading" mt={2} mb={2}>
              {t('Use location')}
            </Typography>
            <Typography variant="body2" className="popupContent">
              {t('Please give us access')}
              <br />
              {t('Your position which is required')}
              <br />
              {t('For the next step')}
            </Typography>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Grid container spacing={2} alignItems="center">
              <Grid item xs="auto">
                <Typography variant="subtitle1" color="#c8c8c8">
                  1 {t('of')} 2
                </Typography>
              </Grid>
              <Grid item xs>
                {/* <Link to="" className="mainBtn" onClick={handleClickOpenSec} autoFocus> */}
                <Link to="" className="mainBtn mb-0" onClick={handleClickOpenSec} autoFocus>
                  {t('Continue')}
                </Link>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openSec}
          onClose={handleCloseSec}
          aria-labelledby="alert-dialog-title1"
          aria-describedby="alert-dialog-description1"
          className="popupBlue popupBox"
        >
          <DialogTitle id="alert-dialog-title1" className="popupBlueHeading">
            <Box className="popupIconBox">
              <AiFillCamera className="popupIcon" />
            </Box>
            <Typography variant="subtitle1" color="white">
              {t('Allow Camera to take pictures')}
            </Typography>
            <Typography variant="subtitle1" color="white">
              {t('While you use the app')}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="subtitle1" className="popUpHeading" mb={2} mt={2}>
              {t('Camera access')}
            </Typography>
            <Typography variant="body2" className="popupContent">
              {t('Please give us access')}
              <br />
              {t('Your camera which is necessary')}
              <br />
              {t('For the next step')}
            </Typography>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Grid container spacing={2} alignItems="center">
              <Grid item xs="auto">
                <Typography variant="subtitle1" color="#c8c8c8">
                  2 {t('of')} 2
                </Typography>
              </Grid>
              <Grid item xs>
                <Link className="mainBtn mb-0" to="/in/terms-of-use">
                  {t('Allow')}
                </Link>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        {/* validation check popup that kyc is done or not */}
        <Dialog
          fullWidth
          maxWidth="sm"
          open={openDialogKyc}
          onClose={() => {
            closeDialogMsgHandler();
          }}
          className="alertDialogWrap"
        >
          <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1">{t('Message')}</Typography>
            <IconButton onClick={() => setOpenDialogKyc(false)} size="small">
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2">
              {t('Your ekyc completed but video ekyc is pending')}
            </Typography>
          </DialogContent>

          <DialogActions disableSpacing={false} className="popupAction" style={{ padding: '15px' }}>
            <Button
              style={{ backgroundColor: '#111b53' }}
              className="mainBtn"
              variant="contained"
              color="secondary"
              onClick={() => {
                navigate('/in/schedule-vkyc');
                setOpenDialogKyc(false);
              }}
            >
              {t('Schedule book for video Ekyc')}
            </Button>
            <Button
              onClick={() => setOpenDialogKyc(false)}
              variant="contained"
              className="mainBtn"
              color="primary"
            >
              {t('Close')}
            </Button>
          </DialogActions>
        </Dialog>

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default SelfRegistration;
